import { useEffect, useState } from "react";
import ModeSelectionProcess from "./mode-selection-view";
import { useChargesAction } from "../../../../services/actions/charges.action";
import InfoCharge from "../../params/components/info-charge";
import ColorsCircles from "../../params/components/colors-roles";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useNavigate } from "react-router-dom";
import { ROUTES, TEST_ID, CONTACT_EMAIL } from "../../../../helpers/constants";
import CompetencyModeSelector, {
  COMPETENCY_MODE,
  isCompetencySelectionValid,
  selectedCompetencesForPayload,
} from "./competency-mode-selector";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../services/atoms/auth.atoms";
import { useCollaboratorsActions } from "../../../../services/actions/collaborators.actions";
import { HiOutlineCloudUpload, HiOutlinePlusCircle } from "react-icons/hi";
import { statusColors, statusTranslator } from "../../../../helpers/functions";
import {
  AiOutlineClose,
} from "react-icons/ai";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { InputIcon } from "../../../../components/inputs/input-icon";
import { useSelectionProcessAction } from "../../../../services/actions/selection-process.actions";
import { v4 as uuidv4 } from "uuid";
import toast, { Toaster } from "react-hot-toast";
import {
  crudSelectionProcessAtom,
} from "../../../../services/atoms/selection-process.atom";
import EditChargeFromSelectionModal from "./edit-charge-selection-process";
import CreateCollaboratorModal from "../../collaborator-details/components/create-modal";
import BulkLoadModal from "../../clients-details/components/bulk-load-modal";
import BulkLoadErrors from "../../clients-details/components/bulk-load-modal-errors";
import TableComponent from "../../../../components/table/table-component";
import AddCollaboratorModal from "./add-collaborator-modal";
import moment from "moment";
import CreateProcessSelectionAndCharge from "./create-selection-process-charge";

const badgeAccessor = (row) => (
  <div
    className={`gm-badge gm-badge--${statusColors(
      row.length === 0 ? 0 : row[0]?.statusId
    )}`}
  >
    <span>
      {row.length === 0
        ? statusTranslator(0)
        : statusTranslator(row[0]?.statusId)}
    </span>
  </div>
);
const dateFotmatter = (date) => (
  <div>
    {date[0]?.finishedAt
      ? `${moment(date[0]?.finishedAt).format("DD-MM-YYYY HH:mm")} hrs`
      : "--/--/----"}
  </div>
);

const columns = [
  {
    Header: "Nombre",
    accessor: ({ name, surname }) => (
      <div>
        {name} {surname}
      </div>
    ),
    disableSortBy: true,
  },
  {
    Header: "Estado",
    accessor: ({ latestTest }) => badgeAccessor(latestTest),
    disableSortBy: true,
  },
  {
    Header: " % Match",
    accessor: ({ latestTest }) => <div>-</div>,
  },
  {
    Header: "Realizado el",
    accessor: ({ latestTest }) => dateFotmatter(latestTest),
  },
  {
    Header: "Origen",
    accessor: ({ collaboratorInternal }) => (
      <div>{collaboratorInternal ? "Interno" : "Externo"}</div>
    ),
    disableSortBy: true,
  },
];

const stepProcessCreate = [
  { step: 1, name: "CARGO" },
  { step: 2, name: "EVALUACIÓN" },
  { step: 3, name: "VISUALIZAR" },
];

const initialSearchValue = { name: "", position: "" };

const testData = ["Test DISC + motivadores"];

const initialSetOpenState = {
  editCharge: false,
  createCollab: false,
  bulk: false,
  errors: false,
  invitation: false,
};

const initialChargeData = {
  id: "",
  name: "",
  description: "",
  competences: [],
  currentClientsId: "",
  type: "",
};

const CreateSelectionProcess = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const { createProcessSelection } = useSelectionProcessAction();
  const { sendInvitation } = useCollaboratorsActions();
  const { listCharges } = useChargesAction();
  const { listCollaborator } = useCollaboratorsActions();
  const selectionProcessResolver = useRecoilValue(crudSelectionProcessAtom);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const [stepsPass, setSteps] = useState(0);
  const [createProcess, setCreateProcess] = useState(false);
  const [charges, setCharges] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState(initialChargeData);
  const [collaborators, setCollaborators] = useState([]);
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [selectedTest, setSelectedTest] = useState([]);
  const [competencyMode, setCompetencyMode] = useState(COMPETENCY_MODE.PATTERN);
  const [selectedCompetences, setSelectedCompetences] = useState([]);
  const [open, setOpen] = useState(initialSetOpenState);
  const [errorsModal, setErrorsModal] = useState([]);
  const [showCollaborators, setShowCollaborators] = useState(false);
  const [filteredCollaborators, setFilteredCollaborators] = useState([]);
  const [filteredTableCollaborators, setFilteredTableCollaborators] = useState(
    []
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [updatedCollaborators, setUpdatedCollaborator] = useState(false);
  const [rutNewCollab, setRutNewCollab] = useState("");
  const [createdProcess, setCreatedProcess] = useState(false)

  const getCharges = async () => {
    const response = await listCharges({
      currentClientsId: user?.data?.clientId,
    });
    setCharges(response?.data);
  };

  const handleCancelProcess = () => {
    navigate(ROUTES.PROCESS.route);
  };

  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));

  const handleSelect = (key, event) => {
    event.preventDefault();
    if (key === "charge") {
      const selectedCharge = charges.filter(
        (charge) => charge.id === event.target.value
      );
      setSelectedCharge(selectedCharge[0]);
    }
    if (key === "test") {
      setSelectedTest(event.target.value);
    }
  };

  const getCollaborators = async () => {
    const response = await listCollaborator({ clientId: user?.data?.clientId });
    if(response?.data === 0){
      setCollaborators([])
    } else {
      setCollaborators(response?.data) 
    }
  };

  const handleDeleteCollaborator = (id) => {
    setSelectedCollaborators(
      selectedCollaborators.filter((collab) => collab.id !== id)
    );
  };

  const handleSelectAllCollaborators = (e) => {
    if (e.target.checked) {
      setSelectedCollaborators([...collaborators]);
    } else {
      setSelectedCollaborators([]);
    }
  };

  const isCollaboratorSelected = (id) => {
    return selectedCollaborators.some((collab) => collab.id === id);
  };

  const handleSelectCollaborator = (id) => {
    const selectedCollab = collaborators.find((collab) => collab.id === id);
    if (selectedCollab) {
      if (isCollaboratorSelected(id)) {
        setSelectedCollaborators(
          selectedCollaborators.filter((collab) => collab.id !== id)
        );
      } else {
        setSelectedCollaborators((prevValues) => [
          ...prevValues,
          selectedCollab,
        ]);
      }
    }
  };
  const resetSelect = () => {
    const select = document.querySelector('select[name="origen"]');
    select.selectedIndex = 0;
  };

  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSearchByName = (event) => {
    event.preventDefault();
    setFilteredTableCollaborators(selectedCollaborators);
    setSearch(event);
    setIsFiltered(true);
    setFilteredTableCollaborators(
      selectedCollaborators.filter((collab) =>
        collab.name.toLowerCase().includes(searchValues.name.toLowerCase())
      )
    );
  };

  const handleChangeOrigin = (event) => {
    event.preventDefault();
    const selectedValue = event.target.value;
    if (selectedValue !== "false") {
      const origin = event.target.value;
      setFilteredTableCollaborators(selectedCollaborators);
      setSearch(origin);
      setIsFiltered(true);
      setFilteredTableCollaborators(
        selectedCollaborators.filter((collab) =>
          origin === "collaboratorInternal"
            ? collab.collaboratorInternal
            : collab.collaboratorExternal
        )
      );
    } else {
      return;
    }
  };
  const handleCleanSearch = () => {
    setFilteredTableCollaborators(selectedCollaborators);
    setSearch("");
    setSearchValue(initialSearchValue);
    resetSelect();
    setIsFiltered(false);
  };

  const handleSubmit = async () => {
    setCreatedProcess(true)
    const idCollaborators = selectedCollaborators.map((collab) => collab.id);
    const idProcess = uuidv4();
    const data = {
      id: idProcess,
      clientId: user?.data.clientId || "",
      positionId: selectedCharge?.id,
      collaborator: idCollaborators,
    };
    await createProcessSelection(data, (res) => {
      if(res.status === 200){
        sendInvitation(
          {
            testID: `${TEST_ID}`,
            collaboratorIDs: idCollaborators,
            selectedCompetences: selectedCompetencesForPayload(
              competencyMode,
              selectedCompetences
            ),
          },
          () => {
            toast.success("Proceso de Selección creado exitosamente.", {
              duration: 4500,
            });
            setCreatedProcess(false)
            navigate(ROUTES.PROCESS.route);
          }
        );
      } else if (res.status ===400){
        toast.error('El número de invitados supera la cantidad de test disponibles, intenta quitando algunas personas de la lista.', {duration:6000})
        setCreatedProcess(false)
        setSteps(2)
      } else {
        setCreateProcess(false)
        toast.error('Ha ocurrido un error al crear el proceso, por favor, intente nuevamente.', {duration:4000})
      }
    });
  };

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowCollaborators(false);
    }
  };

  const resetSelectCharges = () => {
    const select = document.querySelector('select[name="charges-select"]');
    select.selectedIndex = 0;
  };


  useEffect(() => {
    getCharges();
    getCollaborators();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredCollaborators(
      collaborators.filter(
        (collab) =>
          collab.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          collab.email.toLowerCase().includes(searchTerm.toLocaleLowerCase())
      )
    );
  }, [searchTerm, collaborators]);

  useEffect(() => {
    const newAddedCollaborator = collaborators.find(
      (collaborators) => collaborators.rut === rutNewCollab
    );
    if (newAddedCollaborator)
      if (
        !selectedCollaborators.find(
          (selected) => selected.rut === newAddedCollaborator.rut
        )
      ) {
        setSelectedCollaborators((prevValues) => [
          ...prevValues,
          newAddedCollaborator,
        ]);
      }
    //eslint-disable-next-line
  }, [collaborators]);

  return (
    <div className="gm-selection-process-create-container">
      {open.errors && (
        <BulkLoadErrors
          open={open.errors}
          toggle={() => handleOpenModal("errors")}
          errorsModal={errorsModal}
        />
      )}
      {open.editCharge && (
        <EditChargeFromSelectionModal
          open={open.editCharge}
          toggle={() => handleOpenModal("editCharge")}
          setCharge={setSelectedCharge}
          charge={selectedCharge}
          clientId={user?.data?.clientId}
          update={() => getCharges()}
          resetSelectCharges ={()=> resetSelectCharges()}
        />
      )}

      {open.createCollab && (
        <CreateCollaboratorModal
          open={open.createCollab}
          toggle={() => handleOpenModal("createCollab")}
          clientId={user?.data?.clientId || ""}
          update={() => getCollaborators()}
          charge={selectedCharge?.name}
          setRutNewCollab={setRutNewCollab}
          // setSelectedCollaborators={setSelectedCollaborators}
        />
      )}

      {open.bulk && (
        <BulkLoadModal
          handleOpenModal={() => handleOpenModal("errors")}
          setErrorsModal={setErrorsModal}
          open={open.bulk}
          toggle={() => handleOpenModal("bulk")}
          clientId={user?.data?.clientId || ""}
          update={() => getCollaborators()}
        />
      )}
      {open.invitation && (
        <AddCollaboratorModal
          open={open.invitation}
          toggle={() => handleOpenModal("invitation")}
          clientId={user?.data?.clientId || ""}
          update={() => getCollaborators()}
          handleOpenModal={() => handleOpenModal("createCollab")}
          setSelectedCollaborators={setSelectedCollaborators}
          selectedCollaborators={selectedCollaborators}
        />
      )}
      <Toaster />
      {stepsPass === 0 && (
        <ModeSelectionProcess
          steps={stepsPass}
          setSteps={setSteps}
          setCreateProcess={setCreateProcess}
        />
      )}
      {stepsPass !== 0 && stepsPass !== 4 && (
        <div className="gm-steps-creation-container">
          <h2>Nuevo Proceso de Evaluación</h2>
          {createProcess && (
            <section className="gm-modal-section-circle-steps">
              {stepProcessCreate.map((steps, index) => (
                <div className="gm-modal-section-step">
                  <button
                    onClick={() => {
                      setSteps(index + 1);
                    }}
                    className={
                      steps.step === stepsPass
                        ? "gm-modal-circle-active"
                        : "gm-modal-circles-section"
                    }
                  >
                    {steps.step}
                  </button>
                  <span>{steps.name}</span>
                </div>
              ))}
              <div className="gm-modal-line"></div>
            </section>
          )}
          {createProcess && stepsPass === 1 && (
            <div className="gm-step-container">
              {selectedCharge.name !== "" && (
                <div className="gm-btn-action-selection">
                  <button
                    type="button"
                    className="gm-secondary-button"
                    onClick={() => handleOpenModal("editCharge")}
                  >
                    Editar
                  </button>
                </div>
              )}
              {selectedCharge.name === "" && (
                <span>¿Cuál es el nombre del cargo?</span>
              )}
              <select name='charges-select' onChange={(e) => handleSelect("charge", e)}>
                <option>Seleccionar Cargo</option>
                {charges?.map((charges) => (
                  <option value={charges.id}>{charges.name}</option>
                ))}
              </select>
              {selectedCharge.name !== "" && (
                <div className="gm-container-info-charge">
                  <section className="gm-section-competences-charge">
                    <span>Nombre del Cargo: </span>
                    <div className="gm-name-charge">
                      {selectedCharge && selectedCharge.name}
                    </div>
                    <span>Competencias</span>
                    <div className="competences-selected">
                      {selectedCharge &&
                        selectedCharge?.competences.map((skills) => (
                          <div key={skills.id}>
                            {" "}
                            <span> {skills.name}</span>{" "}
                            <div>
                              {skills.colorType.map((colors) => (
                                <ColorsCircles colors={colors} />
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </section>
                  <section className="gm-section-competences-charge">
                    <span>Descripción</span>
                    <p className="gm-description-charge">
                      {selectedCharge && selectedCharge.description}
                    </p>
                  </section>
                </div>
              )}

              <div className="gm-btn-action-selection">
                <button
                  type="button"
                  className="gm-secondary-button"
                  onClick={() => handleCancelProcess()}
                >
                  Cancelar
                </button>
                <ButtonLoading
                  className="gm-primary-button"
                  type="submit"
                  buttonLabel="Continuar"
                  onClick={() => {
                    setSteps(stepsPass + 1);
                    setCreateProcess(true);
                  }}
                  disabled={selectedCharge.name === ""}
                />
              </div>
            </div>
          )}
          { createProcess && stepsPass === 2 && (
            <div className="gm-step-container">
              <span>Evaluación</span>
              <select onChange={(e) => handleSelect("test", e)}>
                <option>Seleccionar Evaluación</option>
                {testData?.map((test) => (
                  <option value={test}>{test}</option>
                ))}
              </select>
              <div className="gm-selection-add-collab">
                <p
                >
                </p>
                <p>
                ¿Necesitas más test? Escríbenos a <span>{CONTACT_EMAIL}</span>
                </p>
              </div>
              <CompetencyModeSelector
                mode={competencyMode}
                onModeChange={setCompetencyMode}
                selected={selectedCompetences}
                onSelectedChange={setSelectedCompetences}
              />
              <span>¿Quiénes pueden hacer esta evaluación?</span>
              <div
                className="gm-selection-searchbar-collab"
                onFocus={() => setShowCollaborators(true)}
                onBlur={handleBlur}
                tabIndex={-1}
              >
                <input
                  onClick={() => setShowCollaborators(true)}
                  type="text"
                  placeholder="Buscar por nombre o correo"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                />
                {showCollaborators && (
                  <ul>
                    <li>
                      <div>
                        <span>
                          Seleccionar los Colaboradores (
                          {selectedCollaborators.length})
                        </span>
                        <span></span>
                      </div>
                      <div>
                        Seleccionar todos
                        <input
                          type="checkbox"
                          onChange={handleSelectAllCollaborators}
                          checked={
                            collaborators.length > 0 &&
                            selectedCollaborators.length ===
                              collaborators.length
                          }
                        />
                      </div>
                    </li>
                    {filteredCollaborators.map((collab, index) => (
                      <li key={index}>
                        <div>
                          <span>{`${collab.name} ${collab.surname}`}</span>
                          <span>{collab.email}</span>
                        </div>
                        <div>
                          {collab.collaboratorInternal ? "Interno" : "Externo"}
                          <input
                            type="checkbox"
                            checked={selectedCollaborators.some(
                              (selected) => selected.id === collab.id
                            )}
                            onChange={() => handleSelectCollaborator(collab.id)}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="gm-selection-add-collab">
                <button
                  type="button"
                  onClick={() => handleOpenModal("createCollab")}
                >
                  <HiOutlinePlusCircle /> Nuevo Colaborador
                </button>
                <button type="button" onClick={() => handleOpenModal("bulk")}>
                  <HiOutlineCloudUpload /> Creación con Carga Masiva
                </button>
              </div>
              {selectedCollaborators.length !== 0 && (
                <ul>
                  {selectedCollaborators.map((collab) => (
                    <li>
                      <div>
                        <span> {`${collab.name} ${collab.surname}`} </span>
                        <span> {collab.email}</span>
                      </div>
                      <div>
                        {" "}
                        {collab.collaboratorInternal
                          ? "Interno"
                          : "Externo"}{" "}
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => {
                            handleDeleteCollaborator(collab.id);
                          }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}{" "}
              <div className="gm-btn-action-selection">
                <button
                  type="button"
                  className="gm-secondary-button"
                  onClick={() => handleCancelProcess()}
                >
                  Cancelar
                </button>
                <ButtonLoading
                  className="gm-primary-button"
                  type="submit"
                  buttonLabel="Continuar"
                  onClick={() => {
                    setSteps(stepsPass + 1);
                    setCreateProcess(true);
                  }}
                  disabled={
                    selectedCollaborators.length === 0 ||
                    selectedTest.length === 0 ||
                    !isCompetencySelectionValid(competencyMode, selectedCompetences)
                  }
                />
              </div>
            </div>
          )}
          {createProcess && stepsPass === 3 && (
            <div className="gm-step-container-preview">
              <InfoCharge charge={selectedCharge} />
              <div style={{ height: "35px" }}></div>
              <div>
                <div className="gm-ts-searchbar-container">
                  <div className="gm-ts-searchbar-title-container"></div>
                  <div className="gm-ts-searchbar-actions-container">
                    <form onSubmit={(e) => handleSearchByName(e, "name")}>
                      <InputIcon
                        Icon={HiMagnifyingGlass}
                        type="text"
                        placeholder="Buscar por nombre"
                        name="search"
                        value={searchValues.name}
                        onChange={(e) =>
                          handleChangeValue("name", e.target.value)
                        }
                      />
                    </form>
                    <form>
                      <div className="gm-input-icon-container">
                        <select
                          name="origen"
                          onChange={(event) => {
                            handleChangeOrigin(event);
                          }}
                        >
                          <option value={false}>Filtrar por origen</option>
                          <option value="collaboratorInternal">Interno</option>
                          <option value="collaboratorExternal">Externo </option>
                        </select>
                      </div>
                    </form>
                    {searchExists && (
                      <button
                        className="gm-clean-search-button"
                        onClick={handleCleanSearch}
                        type="button"
                      >
                        <AiOutlineClose size={18} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <TableComponent
                header="primary-green"
                columns={columns}
                data={
                  isFiltered
                    ? filteredTableCollaborators
                    : selectedCollaborators || []
                }
                loading={updatedCollaborators}
              />
              <footer>
                <button
                  type="button"
                  className="gm-secondary-button"
                  onClick={() => handleCancelProcess()}
                >
                  Cancelar
                </button>
                <ButtonLoading
                  className="gm-primary-button"
                  type="submit"
                  buttonLabel="Crear Proceso"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={
                    selectedCharge.name === "" || selectedTest.length === 0 || selectedCollaborators.length === 0 ||
                    !isCompetencySelectionValid(competencyMode, selectedCompetences)
                  }
                  loading={createdProcess}
                />
              </footer>
            </div>
          )}

          {!createProcess && (
            <CreateProcessSelectionAndCharge />
          )}
        </div>
      )}
    </div>
  );
};

export default CreateSelectionProcess;
